// extracted by mini-css-extract-plugin
module.exports = {"containerButtons":"styles_containerButtons__xz4bZ","scrollbars":"styles_scrollbars___3cNa","slideInSearchBar":"styles_slideInSearchBar__c_sYK"};